/**
 * Helper component that lests users select items from a complex array of objects
 *
 * NOTE: To use -
 * // this example shows how to assign an author to a post
 * render() {
 *   let authors = [
 *     { name: 'Bill', _id: '55XYZ' }
 *     , { name: 'Jenny', _id: '56ABC' }
 *     , { name: 'Steve', _id: '57DEF' }
 *   ];
 *   return (
 *     <div>
 *       <SelectFromObject
 *         change={handleFormChange}
 *         clearable={false}
 *         disabled={false}
 *         display={'name'}
 *         filterable={true}
 *         label="Author"
 *         name="author"
 *         objects={authors}
 *         placeholder="-- Select an author --"
 *         required={true}
 *         selected={post.author}
 *         value={'_id'}
 *       />
 *     </div>
 *   )
 * }
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

// import components
import Base from "../BaseComponent.js.jsx";

// import third party libraries
import FilterableSelect from 'react-select';

class SelectFromObject extends Base{
  constructor(props, context) {
    super(props);
    this.state = {
      selected: this.props.selected || ''
    }
    this._bind('_handleSelectChange');
  }

  // check agains any new props the component receives
  componentWillReceiveProps(nextProps) {
    nextProps.selected ? this.setState({selected: nextProps.selected}) : '';
  }

  _handleSelectChange(e) {
    const { change, filterable, name } = this.props;
    if(filterable) {
      let event = {target: {}};
      event.target.name =  name;
      event.target.value = e ? e.value : null;
      this.setState({
        selected: e ? e.value : null
      });
      change(event);
    } else {
      this.setState({
        selected: e.target.value
      });
      change(e);
    }
  }

  render() {
    const {
      clearable
      , disabled
      , display
      , filterable
      , helpText
      , label
      , name
      , objects
      , placeholder
      , required
      , value
    } = this.props;

    // build the items to select from
    let options = [];
    let filterableOptions = [];
    // objects is an array
    if(typeof(options) == "array") {
      options = objects.map((object, index) => {
        return (
          <option key={index} value={object[value]}>
            {object[display]}
          </option>
        )
      });
    } else {
      // objects is a map {}
      for(let i in objects) {
        if(objects.hasOwnProperty(i)) {
          /**
           * if object has an _id, make that the iterator key, otherwise use object[value]
           * since that is supposed to be unique.
           */
          options.push(
            <option
              key={objects[i]._id ? objects[i]._id : objects[i][value]}
              value={objects[i][value]}
            >
              {objects[i][display]}
            </option>
          )
          // filterable options
          let fOptions = {};
          fOptions.value = objects[i][value];
          fOptions.label = objects[i][display];
          fOptions.name = name;
          fOptions.clearableValue = false;
          filterableOptions[i] = fOptions;
        }
      }
    }
    // render placeholder
    if(placeholder) {
      let placeholderText = <option key="-1" value={''}>{placeholder}</option>;
      options.unshift(placeholderText);
    }

    return (
      <div className="select-from-object input-group">
        <label htmlFor={name}>{label} {required ? <sup className="-required">*</sup> : null}</label>
        { filterable ?
            <FilterableSelect
              clearable={clearable}
              disabled={disabled}
              name={name}
              onChange={this._handleSelectChange}
              options={filterableOptions}
              placeholder={placeholder}
              required={required}
              value={this.state.selected}
            />
          :
            <select
              disabled={disabled}
              name={name}
              onChange={this._handleSelectChange}
              placeholder={placeholder}
              required={required}
              value={this.state.selected}
            >
              {options}
            </select>
        }
        <small className="help-text"><em>{helpText}</em></small>
      </div>
    )
  }
}

SelectFromObject.propTypes = {
  change: PropTypes.func.isRequired
  , clearable: PropTypes.bool
  , disabled: PropTypes.bool
  , display: PropTypes.string.isRequired
  , filterable: PropTypes.bool
  , helpText: PropTypes.any
  , label: PropTypes.string
  , name: PropTypes.string
  , objects: PropTypes.oneOfType([
    PropTypes.array
    , PropTypes.object
  ]).isRequired
  , placeholder: PropTypes.string
  , required: PropTypes.bool
  , selected: PropTypes.string
  , value: PropTypes.string.isRequired
}

SelectFromObject.defaultProps = {
  clearable: true
  , disabled: false
  , filterable: false
  , helpText: null
  , label: ''
  , name: ''
  , placeholder: '-- Select from the following --'
  , required: false
  , selected: ''
}

export default SelectFromObject;


// WEBPACK FOOTER //
// global/components/forms/SelectFromObject.js.jsx